import Http from 'services/http2';
import User from 'services/user2';
import Modal from 'services/modal';
import BaseService from 'services/base';

const OrderService = Object.assign(
  {
    save(config: any = {}, cb: Function = () => {}, dispatch: Function) {},

    //同意订单答交
    //操作类型 operateType  1:同意；2：确认
    consentOrderReply(
      postbody: any,
      cb: Function = () => {},
      dispatch: Function
    ) {
      let ok = () => {
        let config = {
          operateType: 1,
          ...postbody,
          rejectReason: '',
          action: 'consent',
          apiPath: '/purchase/dealAnswer'
        };
        this.save(config, cb, dispatch);
      };
      Modal.showConfirm('您确定同意答交数据吗？', ok, dispatch);
    },

    //退回订单答交
    rejectOrderReply(
      postbody: any,
      cb: Function = () => {},
      dispatch: Function
    ) {
      let ok = () => {
        let config = {
          ...postbody,
          //rejectReason: reason,
          action: 'reject',
          apiPath: '/purchase/dealAnswer'
        };
        this.save(config, cb, dispatch);
      };
      Modal.showConfirm('您确定退回答交数据吗？', ok, dispatch);
    },

    //订单发布
    publishOrder(postbody: any, cb: Function = () => {}, dispatch: Function) {
      let ok = () => {
        let config = {
          ...postbody,
          apiPath: '/purchase/publishOrder',
          successMsg: '发布成功'
        };
        this.save(config, cb, dispatch);
      };
      Modal.showConfirm('您确定发布采购订单吗？', ok, dispatch);
    },

    //采购订单撤回
    purchaseRecall(postbody: any, cb: Function = () => {}, dispatch: Function) {
      let ok = () => {
        let config = {
          ...postbody,
          apiPath: '/purchase/revoke'
        };
        this.save(config, cb, dispatch);
      };
      Modal.showConfirm('确认撤回？', ok, dispatch);
    },

    //订单发送
    sendOrder(postbody: any, cb: Function = () => {}, dispatch: Function) {
      let ok = () => {
        let config = {
          ...postbody,
          apiPath: '/purchase/sendOrderSyncBoard'
        };
        this.save(config, cb, dispatch);
      };
      Modal.showConfirm('您确定发送采购订单吗？', ok, dispatch);
    },

    //客户订单确认
    customerOrderConfirm(
      poXkNos: any[],
      cb: Function = () => {},
      dispatch: Function
    ) {
      let ok = () => {
        let postbody = {
          companyCode: User.getCompanyCode(),
          poXkNos,
          apiPath: '/customerPurchase/confirm'
        };
        Modal.showLoading(dispatch);
        Http.post('/api/cloudCenter?btnId=001', postbody).then(response => {
          Modal.hideLoading(dispatch);
          if (response.success) {
            Modal.showTip('订单确认成功', dispatch);
          } else if (response.errorMsg) {
            Modal.showError(response.errorMsg, dispatch);
          }
          cb(response); //部分失败时也需要刷新列表
        });
      };
      Modal.showConfirm(
        '未答交订单将直接确认同意客户订单的交货条件，已答交订单将答交信息发送给客户。',
        ok,
        dispatch
      );
    },

    //发布请购单
    publishRequisition(postbody, cb: Function = () => {}, dispatch: Function) {
      let ok = () => {
        let config = {
          ...postbody,
          apiPath: '/b2bRequisitionOrder/publish',
          successMsg: '发布成功'
        };
        this.save(config, cb, dispatch);
      };
      Modal.showConfirm('确认发布请购单？', ok, dispatch);
    },
    // 确认发出交料通知单
    publishAcnOrder(postbody, cb: Function = () => {}, dispatch: Function) {
      let ok = () => {
        let config = {
          ...postbody,
          successMsg: '操作成功'
        };
        this.save(config, cb, dispatch);
      };
      Modal.showConfirm('确认发布交料通知？', ok, dispatch);
    },

    // 供应商答交交料通知单
    answerAcnOrder(postbody, cb: Function = () => {}, dispatch: Function) {
      let ok = () => {
        let config = {
          ...postbody,
          successMsg: '操作成功'
        };
        this.save(config, cb, dispatch);
      };
      Modal.showConfirm('您是否确认此操作？', ok, dispatch);
    },

    //同意订单变更
    agreeChangeOrder(
      postbody: any,
      cb: Function = () => {},
      dispatch: Function
    ) {
      let ok = () => {
        let config = {
          ...postbody,
          apiPath: '/change/answer/agree'
        };
        this.save(config, cb, dispatch);
      };
      Modal.showConfirm('确认同意该变更？', ok, dispatch);
    },

    //退回订单变更
    rejectChangeOrder(
      postbody: any,
      cb: Function = () => {},
      dispatch: Function
    ) {
      let ok = (reason?) => {
        if (!reason) {
          Modal.showError('退回原因不能为空', dispatch);
          return;
        }
        let config = {
          ...postbody,
          rejectReason: reason,
          apiPath: '/change/answer/reject'
        };
        this.save(config, cb, dispatch);
      };
      Modal.showReject(
        '您确定退回吗？',
        ok,
        '退回',
        'showReject',
        '',
        dispatch
      );
    },

    //客户变更无差异确认
    customerChangeConfirm(
      postbody: any,
      cb: Function = () => {},
      dispatch: Function
    ) {
      let ok = () => {
        let config = {
          ...postbody,
          apiPath: '/customerChange/nodiffAnswerChange'
        };
        this.save(config, cb, dispatch);
      };
      Modal.showConfirm(
        '您确认同意变更内容吗？ \r  确认后，原有订单答交数据将被变更单数据覆盖。？',
        ok,
        dispatch
      );
    }

    // customerChangeConfirm(pocXkNos: string[], cb: Function = () => {}) {
    //   let ok = () => {
    //     let postbody = {
    //       apiPath: '/customerChange/nodiffAnswerChange',
    //       companyCode: this.user.getDefaultCompanyCode(),
    //       pocXkNos
    //     };
    //     this.dialogService.showLoading();
    //     this.http
    //       .post<UserResponse>('/api/cloudCenter?btnId=001', postbody)
    //       .subscribe(response => {
    //         this.dialogService.hideLoading();
    //         if (response.success) {
    //           this.modal.showTip('MODAL.CONFIRM_SUCCESS');
    //           this.user.getMenuMark();
    //           cb();
    //         } else {
    //           this.modal.showError(response.errorMsg);
    //         }
    //       });
    //   };
    //   this.modal.showConfirm('MODAL.CONFIRM_CONSENT_CHANGES_DATA_COVERAGE', ok);
    // }
  },

  BaseService
);

export default OrderService;
